import React from 'react';
import './CouponStatsCards.css';

const CouponStatsCards = ({ stats }) => {
  return (
    <div className="coupon-stats-cards">
      <div className="stat-card">
        <div className="stat-icon blue">
          <span>🎟️</span>
        </div>
        <div className="stat-content">
          <div className="stat-number">{stats.active}</div>
          <div className="stat-label">Active Coupons</div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon green">
          <span>✅</span>
        </div>
        <div className="stat-content">
          <div className="stat-number">{stats.totalUsed.toLocaleString()}</div>
          <div className="stat-label">Total Used</div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon yellow">
          <span>💰</span>
        </div>
        <div className="stat-content">
          <div className="stat-number">PKR {(stats.discountGiven / 1000).toFixed(0)}K</div>
          <div className="stat-label">Discount Given</div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon yellow">
          <span>🏆</span>
        </div>
        <div className="stat-content">
          <div className="stat-code">{stats.bestPerformer}</div>
          <div className="stat-label">Most Used</div>
        </div>
      </div>
    </div>
  );
};

export default CouponStatsCards;

